/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Folder_OptionsInputs */

const en_files_folder_options = /** @type {(inputs: Files_Folder_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder options`)
};

const es_files_folder_options = /** @type {(inputs: Files_Folder_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de carpeta`)
};

/**
* | output |
* | --- |
* | "Folder options" |
*
* @param {Files_Folder_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_folder_options = /** @type {((inputs?: Files_Folder_OptionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Folder_OptionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_folder_options(inputs)
	return en_files_folder_options(inputs)
});